module.exports = __webpack_public_path__ + "static/media/SC_A_04.9750f4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/accessorius/SC_A_04.png
// module id = 200
// module chunks = 0